import React from 'react';
import { Grid, Tab } from '@mui/material';
import { Box } from '@mui/system';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import FinancialSettings from './FinancialSettings';
import './Subscription.scss';

const Subscription: React.FC<any> = () => {
    const [value, setValue] = React.useState('1');

    const tabs = [
        {
            label: 'Financial Settings',
            value: '1',
            component: <FinancialSettings />
        }
    ];

    return (
        <Grid container rowSpacing={1} columnSpacing={{ xs: 4, sm: 2, md: 2 }}>
            <Grid
                item
                xs={12}
                sm={12}
                style={{ cursor: 'pointer', height: '100%' }}
            >
                <Box className="subscription-root">
                    <TabContext value={value}>
                        <Box className="subscription-tabs-wrapper">
                            <TabList
                                onChange={(_e, newValue) => setValue(newValue)}
                                aria-label="subscription tabs"
                                className="subscription-tab-list"
                            >
                                {tabs.map((tab) => (
                                    <Tab
                                        key={tab.value}
                                        value={tab.value}
                                        label={tab.label}
                                        className="subscription-tab"
                                        sx={{ textTransform: 'none' }}
                                    />
                                ))}
                            </TabList>
                        </Box>

                        {tabs.map((tab) => (
                            <TabPanel
                                key={tab.value}
                                value={tab.value}
                                className="subscription-tab-panel"
                            >
                                {tab.component}
                            </TabPanel>
                        ))}
                    </TabContext>
                </Box>
            </Grid>
        </Grid>
    );
};

export default Subscription;